export const EVENTS = {
    SESSION_CREATED: 'session_created',
    SESSION_CREATE_CLICKED: 'session_create_clicked',
    SESSION_JOINED: 'session_joined',
    SESSION_JOIN_ATTEMPTED: 'session_join_attempted',
    SESSION_LEFT: 'session_left',
    SESSION_DISBANDED: 'session_disbanded',
    OAUTH_INITIATED: 'oauth_initiated',
    ANONYMOUS_IDENTITY_SET: 'anonymous_identity_set',
    VOTE_CAST: 'vote_cast',
    CARDS_REVEALED: 'cards_revealed',
    VOTING_RESTARTED: 'voting_restarted',
    ROLE_SWITCHED: 'role_switched',
    EMOJI_THROWN: 'emoji_thrown',
    PROFILE_NAME_CHANGED: 'profile_name_changed',
    OAUTH_LINK_INITIATED: 'oauth_link_initiated',
    OAUTH_UNLINKED: 'oauth_unlinked',
    AVATAR_CLEARED: 'avatar_cleared',
    AVATAR_SET: 'avatar_set',
    ACCOUNT_CLOSED: 'account_closed',
    EMAIL_AUTH_STARTED: 'email_auth_started',
    EMAIL_CODE_SENT: 'email_code_sent',
    EMAIL_CODE_VERIFIED: 'email_code_verified',
    EMAIL_CODE_RESENT: 'email_code_resent',
    EMAIL_CODE_FAILED: 'email_code_failed',
    SETTINGS_EMAIL_CODE_SENT: 'settings_email_code_sent',
    SETTINGS_EMAIL_VERIFIED: 'settings_email_verified',
    SETTINGS_EMAIL_CODE_FAILED: 'settings_email_code_failed',
    STORY_NOTES_UPDATED: 'story_notes_updated',
    STORY_FINAL_ESTIMATE_SET: 'story_final_estimate_set',
    VOTING_TIMER_CONFIGURED: 'voting_timer_configured',
    SESSION_SYNC_ENABLED: 'session.sync_enabled',
    ESTIMATE_SYNCED_TO_SOURCE: 'estimate.synced_to_source',
    CONTACT_FORM_SUBMITTED: 'contact_form_submitted',
    NOTION_IMPORT_COMPLETED: 'notion_import_completed',
    GITHUB_IMPORT_COMPLETED: 'github_import_completed',
    JIRA_IMPORT_COMPLETED: 'jira_import_completed',
    CSV_IMPORT_COMPLETED: 'csv_import_completed',
    DECK_SAVED: 'deck_saved',
    DECK_DELETED: 'deck_deleted',
    UPGRADE_PROMPT_SHOWN: 'upgrade_prompt_shown',
    UPGRADE_PROMPT_CLICKED: 'upgrade_prompt_clicked',
    SESSION_LIST_FILTERED: 'session_list_filtered',
    SESSION_LIST_SORTED: 'session_list_sorted',
    SUBSCRIPTION_STARTED: 'subscription_started',
    SUBSCRIPTION_CANCELLED: 'subscription_cancelled',
    PRICING_SIGNIN_OPENED: 'pricing_signin_opened',
    LANDING_CTA_CLICKED: 'landing_cta_clicked',
    LANDING_PRICING_CLICKED: 'landing_pricing_clicked',
    FAQ_QUESTION_EXPANDED: 'faq_question_expanded',
    API_KEY_CREATED: 'api_key_created',
    API_KEY_REVOKED: 'api_key_revoked',
    API_KEY_PLAINTEXT_COPIED: 'api_key_plaintext_copied',
    API_KEY_ADVANCED_USED: 'api_key_advanced_used',
    API_PLAYGROUND_USED: 'api_playground_used',
    API_DOCS_VIEWED: 'api_docs_viewed',
    INTEGRATIONS_API_BLOCK_CLICKED: 'integrations_api_block_clicked',
    WEBHOOK_CREATED: 'webhook_created',
    WEBHOOK_DELETED: 'webhook_deleted',
    WEBHOOK_ENABLED: 'webhook_enabled',
    WEBHOOK_DISABLED: 'webhook_disabled',
    WEBHOOK_SIGNING_SECRET_COPIED: 'webhook_signing_secret_copied',
    ACCESSIBILITY_PREFERENCE_CHANGED: 'accessibility_preference_changed',
    ACCESSIBILITY_RESET: 'accessibility_reset',
    NEWSLETTER_SIGNED_UP: 'newsletter_signed_up',
    NOTIFICATION_PREFERENCES_UPDATED: 'notification_preferences_updated',
    PUSH_SUBSCRIBED: 'push_subscribed',
    PUSH_UNSUBSCRIBED: 'push_unsubscribed',
    PUSH_PERMISSION_DENIED: 'push_permission_denied',
    PUSH_PREFERENCES_UPDATED: 'push_preferences_updated',
    SESSION_JOIN_PREFERENCE_UPDATED: 'session_join_preference_updated',
    AI_ESTIMATE_REQUESTED: 'ai_estimate_requested',
    AI_ESTIMATE_APPLIED: 'ai_estimate_applied',
    AI_ENRICH_REQUESTED: 'ai_enrich_requested',
    AI_ENRICH_ACCEPTED: 'ai_enrich_accepted',
    AI_DISAGREEMENT_REQUESTED: 'ai_disagreement_requested',
    AI_RETRO_NARRATIVE_REQUESTED: 'ai_retro_narrative_requested',
    AI_STORY_ORDER_REQUESTED: 'ai_story_order_requested',
    AI_STORY_ORDER_APPLIED: 'ai_story_order_applied',
    AI_STORY_EXPLAIN_REQUESTED: 'ai_story_explain_requested',
    AI_ANALYTICS_INSIGHTS_REQUESTED: 'ai_analytics_insights_requested',
    AI_SESSION_SUMMARY_REQUESTED: 'ai_session_summary_requested',
    AI_ACTION_FAILED: 'ai_action_failed',
    AI_CREDITS_BUY_CLICKED: 'ai_credits_buy_clicked',
    AI_PROVIDER_KEY_ADDED: 'ai_provider_key_added',
    AI_PROVIDER_KEY_REMOVED: 'ai_provider_key_removed',
    TEAM_CREATED: 'team_created',
    TEAM_INVITE_SENT: 'team_invite_sent',
    TEAM_INVITE_ACCEPTED: 'team_invite_accepted',
    TEAM_INVITE_DECLINED: 'team_invite_declined',
    TEAM_MEMBER_REMOVED: 'team_member_removed',
    TEAM_MEMBER_SESSION_ROLE_SET: 'team_member_session_role_set',
    TEAM_LEFT: 'team_left',
    TEAM_DELETED: 'team_deleted',
    TEAM_STARRED: 'team_starred',
    TEAM_CREDITS_CONTRIBUTED: 'team_credits_contributed',
    TEAM_CREDITS_WITHDRAWN: 'team_credits_withdrawn',
    TEAM_CREDITS_POOL_TOGGLED: 'team_credits_pool_toggled',
    TEAM_SESSION_STARTED: 'team_session_started',
    TEAM_LOGO_UPDATED: 'team_logo_updated',
    TEAM_LOGO_REMOVED: 'team_logo_removed',
    TEAM_DECK_UPDATED: 'team_deck_updated',
    TEAM_RENAMED: 'team_renamed',
    AI_TEAM_SUMMARY_REQUESTED: 'ai_team_summary_requested',
    AI_TEAM_INSIGHTS_REQUESTED: 'ai_team_insights_requested',
} as const;

export type EventName = (typeof EVENTS)[keyof typeof EVENTS];

export const SOURCES = {
    DASHBOARD: 'dashboard',
    SESSION_CREATE: 'session_create',
    SESSION_JOIN: 'session_join',
    SETTINGS: 'settings',
    PRICING: 'pricing',
    APP_HEADER: 'app_header',
    API_DASHBOARD: 'api_dashboard',
    AI_FEATURE: 'ai_feature',
    SKYNET: 'skynet',
    UPGRADE_FLOATER: 'upgrade_floater',
} as const;

export type EventSource = (typeof SOURCES)[keyof typeof SOURCES];
